import React, { useState } from 'react';
import './index.scss';
import InitialContext from 'state/static-data/InitialContext';

interface ConditionGroup {
    groupDisplayName: string;
    conditions: {
        title: string;
        link: string;
    }[];
}
interface ConditionPickerWidgetProps {
    conditionGroups: ConditionGroup[];
}

const ConditionPickerWidget = () => {
    const widgetAttr: ConditionPickerWidgetProps = InitialContext.getConditionPickerWidgetAttributes();

    const [activeIndex, setActiveIndex] = useState(0);

    return (
        <div className='clinic-condition-picker-container'>
            <pui-tab-container class='clinic-condition-picker-tab-container'>
                <ul className='clinic-condition-picker-category'>
                    {widgetAttr?.conditionGroups?.map((conditionGroup, i) => (
                        <li
                            key={i}
                            className={`clinic-condition-picker-category-item ${
                                i === activeIndex ? 'clinic-condition-picker-category-item-active' : ''
                            }`}
                            onClick={(e) => {
                                e.target.dispatchEvent(
                                    new CustomEvent('tabSwitch', {
                                        bubbles: true,
                                        detail: { clickIndex: i },
                                    })
                                );
                                setActiveIndex(i);
                            }}
                        >
                            <pui-text
                                textsize='large'
                                fontweight='bold'
                                textcolor={i === activeIndex ? 'white' : 'black'}
                                input={conditionGroup.groupDisplayName}
                            ></pui-text>
                        </li>
                    ))}
                </ul>

                {widgetAttr?.conditionGroups?.map((conditionGroup, i) => (
                    <pui-tab-page status={i === activeIndex ? 'selected' : ''} key={i}>
                        <div className='clinic-condition-picker-card-container'>
                            {conditionGroup.conditions.map((condition, j) => (
                                <>
                                    <a href={condition.link}>
                                        <div className='clinic-condition-picker-card' key={i + ' ' + j}>
                                            <pui-text textsize='extra-large' input={condition.title}></pui-text>
                                            <svg
                                                width='8'
                                                height='14'
                                                viewBox='0 0 8 14'
                                                fill='none'
                                                xmlns='http://www.w3.org/2000/svg'
                                            >
                                                <path
                                                    fillRule='evenodd'
                                                    clipRule='evenodd'
                                                    d='M5.24471 7.1076L0 1.86082L1.40679 0.5L8 7.09582L1.70872 13.5L0.289962 12.1513L5.24471 7.1076Z'
                                                    fill='#252F3D'
                                                />
                                            </svg>
                                        </div>
                                    </a>
                                </>
                            ))}
                        </div>
                    </pui-tab-page>
                ))}
            </pui-tab-container>
        </div>
    );
};
export default ConditionPickerWidget;
